import { getHighlightedHTML } from "pages/DevelopWorkspace/Editor/TabsBar/components/HintTooltip/HintTooltip";

import { Copy } from "../DocumentStatistics/QueryStatementsTable/Copy";

import styles from "./TextExplainResult.styles.module.scss";

type Props = {
  explain: string;
};

export const TextExplainResult = (props: Props) => {
  const { explain } = props;
  return (
    <div className={styles.explain}>
      <div className={styles.header}>
        <span className={styles.name}>Explain</span>
      </div>
      <div
        className={styles.query}
        // eslint-disable-next-line react/no-danger -- html is sanitized
        dangerouslySetInnerHTML={{
          __html: getHighlightedHTML(explain),
        }}
      />

      <Copy
        text={explain}
        className={styles.copy}
      />
    </div>
  );
};
